import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`sticky top-0 z-[999] w-full transition-all duration-500 font-poppins
      ${scrolled ? 'bg-white/80 backdrop-blur-lg shadow-lg py-2' : 'bg-white py-5'}`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative flex justify-center items-center h-16">
          
          {/* Logo Fluenesia di Tengah */}
          <Link to="#" className="flex items-center hover:opacity-80 transition-all duration-300">
            <img 
              src="/Fluenesia.png" 
              alt="Fluenesia Logo" 
              className="h-8 w-auto object-contain" 
            />
          </Link>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;